import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import TypeOfServece from './TypeOfServece';
import { payTypeObj } from '../../utils/enums';

const TypeOfServiceContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [servicesList, setServicesList] = useState([]);

    const { clinicId, buildingId, isReferral } = useParams();
    const userId = sessionStorage.getItem('userId');

    const getResearchesList = () => {
        setIsLoading(true);
        const payType = [payTypeObj[isReferral]];
        axios.get(`${process.env.REACT_APP_API}api/v1.0/doctors?UserId=${userId}&BuildingId=${buildingId}&ClinicId=${clinicId}&PayType=${payType}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setServicesList(res.data.navigationItems || [])
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        if (userId) {
            getResearchesList();
        }
    }, [])

    const handleSelectService = (id, name) => {
        history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/doctors/${clinicId}/${buildingId}/${id}/${name}/${isReferral}`);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <TypeOfServece
                isLoading={isLoading}
                servicesList={servicesList}
                handleClickCard={handleSelectService}
                isReferral={isReferral === "1" ? true : false}
            />
        </>
    )
}

export default TypeOfServiceContainer;
